import { Loader2, Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import type { ChatSearchHit } from './useChatSearch';

export function ChatSearchInput({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (
    <div className="relative">
      <Search aria-hidden className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { e.stopPropagation(); if (e.key === 'Escape') onChange(''); }}
        placeholder="Search chats"
        aria-label="Search chats"
        className="h-8 pl-8 pr-7 text-base sm:text-sm"
      />
      {value && (
        <button type="button" aria-label="Clear search" onClick={() => onChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground">
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}

export function ChatSearchResults({ hits, searching, onOpen, titleOf }: {
  hits: ChatSearchHit[];
  searching: boolean;
  onOpen: (id: string) => void;
  titleOf?: (title: string | null) => string;
}) {
  if (searching && hits.length === 0) {
    return <p className="flex items-center gap-2 px-2 py-2 text-xs text-muted-foreground"><Loader2 className="h-3 w-3 animate-spin" />Searching…</p>;
  }
  if (hits.length === 0) return <p className="px-2 py-2 text-xs text-muted-foreground">No chats match that.</p>;
  return (
    <>
      {hits.map((h) => (
        <button key={h.thread_id} type="button" onClick={() => onOpen(h.thread_id)}
          className="block w-full rounded-md px-2 py-2 text-left hover:bg-muted">
          <span className="block truncate text-sm">{titleOf ? titleOf(h.title) : h.title || 'Untitled'}</span>
          {h.snippet && <span className="line-clamp-2 text-xs text-muted-foreground">{h.snippet}</span>}
        </button>
      ))}
    </>
  );
}
